import { serverMessage, tournamentPlayers } from '@/mainComponent/store/interfaces/newInterfaces/types';
import { SetAchievement } from '@/adapter/items/SetAchievement';
import { IAchievement } from '@/mainComponent/store/interfaces/newInterfaces/IAchievement';
import { IAchievementCounter } from '@/mainComponent/store/interfaces/newInterfaces/IAchievementCounter';
import { ITournament } from '@/mainComponent/store/interfaces/newInterfaces/ITournament';
import { ILogin } from '@/mainComponent/store/interfaces/newInterfaces/ILogin';
import { IPrizeSpins } from '@/mainComponent/store/interfaces/newInterfaces/IPrizeSpins';
import { IPayment } from '@/mainComponent/store/interfaces/newInterfaces/IPayment';
import { IUpdate } from '@/mainComponent/store/interfaces/newInterfaces/IUpdate';
import { ICreate } from '@/mainComponent/store/interfaces/newInterfaces/ICreate';
import { IDelete } from '@/mainComponent/store/interfaces/newInterfaces/IDelete';
import { Validator } from '@/utils/ajv/ajv';
import { PromoComponent } from '@/mainComponent/PromoComponent';
import { SetTournaments } from '@/adapter/items/SetTournaments';

class Adapter {
  achievement: SetAchievement;
  tournament: SetTournaments;

  constructor() {
    this.init();
  }

  init(): void {
    this.achievement = new SetAchievement();
    this.tournament = new SetTournaments();
  }
  setData(message: serverMessage) {
    Validator.validate(message.command, message);
    if (message.command === 'login') {
      this.achievement.setRequirements((<ILogin>message.data).requirements);
      this.tournament.setRequirements((<ILogin>message.data).requirements);
      this.setPromotions((<ILogin>message.data).promotions);
      this.setPrizes((<ILogin>message.data).prizes, (<ILogin>message.data).requirements);
      if (
        (game.store.gameData.state === 'idle' || game.store.gameData.state === 'waitSpin') &&
        !game.store.promo.isStartPromo
      )
        game.emit(PromoComponent.events.RECEIVE_FIRST_DATA);
    }

    if (message.command === 'update') {
      if (
        (<IUpdate>message.data).type === 'achievement' ||
        (<IUpdate>message.data).type === 'achievementCounter' ||
        (<IUpdate>message.data).type === 'tournament'
      ) {
        this.setPromotions([message.data]);
      }
      if (
        (<IUpdate>message.data).type === 'freeSpins' ||
        (<IUpdate>message.data).type === 'freeRounds' ||
        (<IUpdate>message.data).type === 'bonusGame' ||
        (<IUpdate>message.data).type === 'payment'
      ) {
        this.setPrizes([message.data]);
      }
    }

    if (message.command === 'create') {
      if (
        (<ICreate>message.data).type === 'achievement' ||
        (<ICreate>message.data).type === 'achievementCounter' ||
        (<ICreate>message.data).type === 'tournament'
      )
        this.setPromotions([message.data]);
      if (
        (<ICreate>message.data).type === 'freeRounds' ||
        (<ICreate>message.data).type === 'freeSpins' ||
        (<ICreate>message.data).type === 'bonusGame' ||
        (<ICreate>message.data).type === 'payment'
      )
        this.setPrizes([message.data]);
    }

    if (message.command === 'delete') {
      if (
        (<IDelete>message.data).type === 'achievement' ||
        (<IDelete>message.data).type === 'achievementCounter' ||
        (<IDelete>message.data).type === 'tournament'
      )
        this.deletePromotion(message.data);
      if (
        (<IDelete>message.data).type === 'freeRounds' ||
        (<IDelete>message.data).type === 'freeSpins' ||
        (<IDelete>message.data).type === 'bonusGame' ||
        (<IDelete>message.data).type === 'payment'
      )
        this.deletePrize(message.data);
    }

    if (message.command === 'get') {
      switch (message.query) {
        case 'tournamentTable':
          this.setTournamentPlayers(message.data);
          break;
      }
    }
  }

  setPromotions(promotions: (IAchievementCounter | IAchievement | ITournament)[]) {
    const promo = promotions[0];
    if (!promo) return;
    switch (promo.type) {
      case 'achievement':
        this.achievement.setAchievement(promo);
        break;
      case 'achievementCounter':
        this.achievement.setAchievement(promo);
        break;
      case 'tournament':
        this.tournament.setTournament(<ITournament>promo);
        break;
    }
  }

  deletePromotion(promotion: IAchievementCounter | IAchievement | ITournament): void {
    switch (promotion.type) {
      case 'achievement' || 'achievementCounter':
        this.achievement.deleteAchievement(promotion);
        break;
      case 'tournament':
        this.tournament.deleteTournament();
        return;
    }
  }

  deletePrize(prize: IPrizeSpins | IPayment) {
    game.store.promo.resetAchievement();
    game.store.promo.resetTournament();
    game.store.promo.resetFreeRounds();
    this.achievement.sendData();
    this.tournament.sendTournamentData();
  }

  setPrizes(prizes: (IPrizeSpins | IPayment)[], requirements?: any): void {
    const prize = prizes[0];
    if (!prize) return;
    switch (true) {
      case prize.promotionType === 'api':
        if (prize.roundsLeft > 0) {
          game.store.promo.isStartedPromo = false;
        }
        this.achievement.setFreeRoundsWithoutAchievement(prize as IPrizeSpins, requirements);
        break;
      case game.store.promo.isTournament:
        this.tournament.setPrize(prize);
        break;
      default:
        this.achievement.setPrize(prize);
    }
  }

  setTournamentPlayers(data: { players: tournamentPlayers }): void {
    this.tournament.setPlayers(data);
  }
}

export { Adapter };
